import type { PhonemeSpan, Span } from "../api/transcription";
import type { Partition } from "../components/AudioWave/AudioWave";

export const partitionsToSpans = (
  partitions: Partition[],
  audioDuration: number,
): (Span | PhonemeSpan)[] => {
  const sortedPartitions = [...partitions];
  sortedPartitions.sort((a, b) => a.time - b.time);

  return sortedPartitions.map((partition, index) => ({
    ...partition.spanData,
    end_time:
      index === sortedPartitions.length - 1
        ? audioDuration
        : sortedPartitions[index + 1].time * audioDuration,
    start_time: partition.time * audioDuration,
  }));
};
